import { useState } from "react";
import { CheckIcon as Check, ProhibitIcon as Prohibit, ArrowCounterClockwiseIcon as Reopen, XIcon as X, CircleNotchIcon as Spinner } from "@phosphor-icons/react";

/** Sticky action bar for the checked rules: note + Validate / Reject / Reopen (Iter 40). */
export default function RuleBulkBar({ count, busy, onDecide, onClear }) {
  const [note, setNote] = useState("");
  if (!count) return null;
  const decide = (decision) => onDecide(decision, note.trim() || null).then(() => setNote(""));
  const btn = "inline-flex items-center gap-1 px-2.5 py-1.5 text-xs border transition-colors disabled:opacity-40";
  return (
    <div
      className="ml-card p-3 flex flex-wrap items-center gap-2 border-[var(--ml-primary)]/50 bg-[var(--ml-primary)]/5"
      data-testid="br-bulk-bar"
    >
      <span className="ml-mono text-[10px] uppercase tracking-widest text-[var(--ml-primary)]" data-testid="br-bulk-count">
        {count} selected
      </span>
      <input
        type="text"
        value={note}
        onChange={(e) => setNote(e.target.value)}
        placeholder="Optional decision note (e.g. confirmed with AP team)"
        data-testid="br-bulk-note"
        className="ml-mono text-xs flex-1 min-w-[220px] px-2 py-1.5 border border-[var(--ml-border)] bg-white focus:outline-none focus:border-[var(--ml-primary)]"
      />
      {busy && <Spinner size={12} className="animate-spin" />}
      <button type="button" disabled={busy} onClick={() => decide("validated")} data-testid="br-bulk-validate"
        className={`${btn} border-[#a7f0ba] text-[#0e6027] bg-white hover:bg-[#defbe6]`}>
        <Check size={12} weight="bold" /> Validate
      </button>
      <button type="button" disabled={busy} onClick={() => decide("rejected")} data-testid="br-bulk-reject"
        className={`${btn} border-[var(--ml-border)] text-[var(--ml-text-secondary)] bg-white hover:bg-[var(--ml-surface)]`}>
        <Prohibit size={12} weight="bold" /> Reject
      </button>
      <button type="button" disabled={busy} onClick={() => decide("proposed")} data-testid="br-bulk-reopen"
        className={`${btn} border-[var(--ml-border)] text-[var(--ml-text-secondary)] bg-white hover:bg-[var(--ml-surface)]`}>
        <Reopen size={12} weight="bold" /> Reopen
      </button>
      <button type="button" onClick={onClear} data-testid="br-bulk-clear"
        className="ml-mono text-[10px] uppercase tracking-widest text-[var(--ml-text-secondary)] hover:text-[var(--ml-text-primary)] inline-flex items-center gap-1 px-1">
        <X size={11} weight="bold" /> Clear
      </button>
    </div>
  );
}
